import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const TrashIcon = ({ color = '#B5BCBD', size = 14, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 15 17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color} fillRule="evenodd">
      <path d="M13.398 4.126H1.55c-.218 0-.4.177-.4.39v10.872c0 .85.71 1.54 1.585 1.54h9.48c.875 0 1.585-.69 1.585-1.54V4.516a.399.399 0 0 0-.4-.39zm-8.476 9.651a.521.521 0 0 1-.528.514.521.521 0 0 1-.529-.514V7.243c0-.284.237-.514.528-.514.292 0 .528.23.528.514v6.534zm3.08 0a.521.521 0 0 1-.528.514.521.521 0 0 1-.528-.514V7.243c0-.284.237-.514.528-.514.292 0 .528.23.528.514v6.534zm3.081 0a.521.521 0 0 1-.528.514.521.521 0 0 1-.528-.514l-.001-6.534c0-.284.237-.514.528-.514.292 0 .529.23.529.514v6.534zM14.146 1.559h-3.518L9.789.425A.812.812 0 0 0 9.115.09H5.833a.837.837 0 0 0-.674.336L4.32 1.558H.802a.767.767 0 0 0-.784.762c0 .425.346.762.784.762h13.343a.767.767 0 0 0 .784-.762.767.767 0 0 0-.783-.761z" />
    </g>
  </svg>
);

TrashIcon.propTypes = propTypes;

export default TrashIcon;
